import React from "react";
import StartFile from "./Components/StartFile";

function App() {
  return (
    <div>
      <StartFile />
    </div>
  );
}

export default App;
